export default __webpack_public_path__ + "static/media/I-2023.08c5b28d.pdf";